/**
 * Messages für Spielende und Platzierungen
 */

// 1. Platz - Gewinner
export const WINNER = [
  "SIEG! Du bist der Boss... bis zur nächsten Runde.",
  "Gewonnen! Respekt, Champion!",
  "Erster Platz! Das ist dein Moment.",
  "Du hast's geschafft! Victory!",
];

// 1. Platz mit Punkten
export const WINNER_POINTS = [
  "{points} Punkte auf dein Konto!",
  "Das sind {points} brandneue Punkte für dich!",
  "+{points} Punkte! Fette Beute.",
  "Score: {points}! Sauber.",
];

// 2. Platz
export const SECOND_PLACE = [
  "Zweiter! Fast gewonnen. Fast zählt nicht.",
  "Silber für dich! Knapp daneben ist auch vorbei.",
  "Platz 2. Besser als Letzter, schlechter als Erster.",
  "Vize-Champion! Immerhin was.",
];

// Mittlere Plätze
export const MIDDLE_PLACE = [
  "Platz {position}. Mittelmäßig, wie erwartet.",
  "Position {position}. Nicht gewonnen, nicht verloren.",
  "Platz {position}. Das ist... was.",
  "Du bist auf Platz {position}. Unauffällig.",
];

// Letzter Platz (Shithead)
export const SHITHEAD = [
  "SHITHEAD! Du bist der offizielle Arsch. Glückwunsch.",
  "Letzter Platz! Das Universum hat gesprochen.",
  "Du bist der Verlierer! Shithead des Spiels.",
  "Tja, Letzter. Das Arsch-Leben ist hart.",
];

// Shithead Punkte (0)
export const SHITHEAD_POINTS = [
  "Du bekommst 0 Punkte. Das ist, äh, nichts.",
  "Null Punkte. Wie passend!",
  "0 Punkte. Mehr hast du nicht verdient.",
  "Keine Punkte. Pech gehabt, Loser.",
];

// Partie-Ende (Zusammenfassung)
export const PARTIE_END = [
  "Partie vorbei! Zeit für die Abrechnung.",
  "Das war's! Endstand wird berechnet.",
  "Partie beendet! Wer ist der Champion?",
];

// Partie-Gewinner
export const PARTIE_WINNER = [
  "{name} gewinnt die Partie mit {points} Punkten!",
  "CHAMPION: {name} mit {points} Punkten!",
  "Die Partie geht an {name}! {points} Punkte!",
];

// Spiel-Ende (komplett)
export const GAME_END = [
  "DAS SPIEL IST AUS! Endstand steht.",
  "Game Over! Das war's.",
  "Finale! Spiel beendet.",
];

// Neues Spiel starten
export const NEW_GAME = [
  "Bereit für Revanche? Neues Spiel wartet!",
  "Noch eine Runde? Los geht's!",
  "Rematch? Der Verlierer will bestimmt Revanche.",
];

// Rang-Aufstieg
export const RANK_UP = [
  "Du bist jetzt {rank}! Aufgestiegen!",
  "Rang-Upgrade: {rank}!",
  "Neuer Rang: {rank}! Respekt.",
];

// Rang-Abstieg
export const RANK_DOWN = [
  "Abgestiegen zu {rank}. Autsch.",
  "Neuer Rang: {rank}. Runtergekommen.",
  "Du bist jetzt {rank}. Tja.",
];
